import { coverSigningStatus } from './legacySignedStatus'
import { roofClaimFilled, roofClaimVisible } from './roofClaimGate'

/** A Roof Claim signature is evidence only for its own agreement. */
export function reportCoverSigningStatus(
  customer: Readonly<Record<string, unknown>>,
  company: string,
  products: readonly string[],
  isMain: boolean,
): { signed: boolean; date: number | null } {
  const primary = coverSigningStatus(customer, company)
  if (!roofClaimVisible(isMain, products, customer)) return primary
  const otherProducts = products.some((product) => product !== 'RC')
  if (otherProducts && primary.signed) return primary
  const signed = roofClaimFilled(customer['roof_claiming_client_sign'])
  const rawDate = customer['roof_claiming_client_sign_date']
  const date =
    signed &&
    typeof rawDate === 'number' &&
    Number.isFinite(rawDate) &&
    rawDate > 0 &&
    rawDate < 8.64e15
      ? rawDate
      : null
  return { signed, date }
}
